import { render } from "./StatusLabel.vue?vue&type=template&id=d6bb10da&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=d6bb10da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6bb10da"]])

export default __exports__